import AnalyticsService from "@/api/services/analytics";
import { toCamelCase } from "@estaly/ui";

// Filters can change while a request is still pending: only the latest request may write its results.
let latestGeneralAnalyticsRequest = 0;

const initialState = {
  generalAnalytics: null,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    generalData: (state) => state.generalAnalytics?.general,
    previousPeriodStartDate: (state) => state.generalAnalytics?.previousPeriod?.startDate,
  },
  mutations: {
    setGeneralAnalytics(state, data) {
      state.generalAnalytics = data;
    },
  },
  actions: {
    async fetchGeneralAnalytics({ commit }, params = {}) {
      const requestId = ++latestGeneralAnalyticsRequest;
      const response = await AnalyticsService.fetchIndex(params);
      const isLatest = requestId === latestGeneralAnalyticsRequest;
      if (isLatest && response?.success) commit("setGeneralAnalytics", toCamelCase(response.data)?.analytics);

      return { ...response, isLatest };
    },

    async getOrganizations(_, { startDate, endDate, ...filters }) {
      return await AnalyticsService.getOrganizations(startDate, endDate, filters);
    },

    async getStores(_, { organizationId, startDate, endDate, ...filters } = {}) {
      return await AnalyticsService.getStores(organizationId || null, startDate, endDate, filters);
    },

    async getSellers(_, { storeId, startDate, endDate, ...filters }) {
      return await AnalyticsService.getSellers(storeId, startDate, endDate, filters);
    },
  },
};
